export default {"src":"/_next/static/image/src/assets/img/logo.b59592bb68e5a1fd176bf1b8519ded13.svg","height":253,"width":1647};